import { render, staticRenderFns } from "./resetPwdDc.vue?vue&type=template&id=3e4ba6f0&scoped=true"
import script from "./resetPwdDc.vue?vue&type=script&lang=js"
export * from "./resetPwdDc.vue?vue&type=script&lang=js"
import style0 from "./resetPwdDc.vue?vue&type=style&index=0&id=3e4ba6f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4ba6f0",
  null
  
)

export default component.exports